<template>

    <div class="container">
        
            
               <div class="row mt-2">
                       <div class="col-12"> 
   
                    <div class="table-responsive  tisch ">
                     
                        <table class="table" v-if="myApplications.length>0">
      <thead>
        <tr class="color-bg">
            <th scope="col">N</th>
          <th scope="col">განცხადება</th>
          <th scope="col">თარიღი</th>
          <th scope="col">სტუდენტი</th>
           <th scope="col">მიმღები</th>
           <th scope="col">სტატუსი</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="data of myApplications" :key="data.correspondence[0].correspondenceID">
            <td>{{ data.correspondence[0].correspondence_number }}</td>
          <td > <button style="background: transparent;border:none" type="button"   data-bs-toggle="modal" data-bs-target="#showApplication" @click="showApplication(data.correspondence[0].correspondenceID)">{{ data.correspondence[0].application.applicationName }}</button> </td>
          <td>{{ data.correspondence[0].correspondence_date }}</td>
           <td>{{ data.correspondence[0].student.fname }} {{ data.correspondence[0].student.lname }} ({{ data.correspondence[0].student.code }})</td>
           <td>
            
            <p style="font-size: 12px;" class="text-muted m-0" v-if="data.isForwarded">გადამისამართებულია</p>
            {{ data.person.fname }} {{ data.person.lname }}
          </td>
           <td>{{ data.correspondence[0].correspondence_status.status }}  </td>
        </tr>
       
        
      </tbody>
    </table>
    
    
                </div>
    
    
                </div>
    
            </div>
    
    
        </div>
       
 
        <div v-if="myApplications.length>0" class="modal fade" id="showApplication" tabindex="-1" role="dialog" aria-labelledby="showApplicationTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">{{ title}}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
           <div class="modal-body">
            
            <span v-html="header"></span>
            <span v-html="body"></span>
            <span>{{ freeText }}</span>
            
            <div v-if="moduleName">
    
              საგანში: {{moduleName}}
    
            </div>
    
    
            <div v-if="cancelDate">
    
              {{cancelDate}}-დან
              
            </div>
              
    
    
            <div class="row m-5">
              <div class="col-6 d-grid">
                <button @click="setStatus(chosenCorrespondence,2)" class="btn btn-outline-success">დაკმაყოფილდეს</button>
              </div>
              <div class="col-6 d-grid">
                <button @click="setStatus(chosenCorrespondence,3)" class="btn btn-outline-danger">არ დაკმაყოფილდეს</button>
              </div>
            </div>

            <div class="row m-5">
              <div class="col-12">
                <p>რეზოლუცია</p>
                <textarea class="form-control" v-model="resolution" @blur="setResolution(chosenCorrespondence)"></textarea>
              </div>
            </div>


            <div class="row m-5">
              <div class="col-12">
                <p>გადამისამართება</p>
                <select class="form-select" v-model="personID" @change="forwardCorrespondence(chosenCorrespondence)">
                    <option value="0">თანამშრომელი...</option>
                    <option :value="person.personID" v-for="person in persons" :key="person.personID">{{ person.fname }} {{ person.lname }}</option>
                    </select> 
              </div>
            </div>





    
          </div>   
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
       
          </div>
        </div>
      </div>
    </div>
    </template>
    
    <script> 
    import HttpRequests from '../httpRequests/httpRequests';
    const httpRequests=new HttpRequests()
     export default{
    
      data(){
    
        return{
    
          myApplications:[],
         
          title:null,
          header:null,
          body:null,
          freeText:null,
          moduleName:null,
          cancelDate:null,
          chosenCorrespondence:0,
          resolution:null,
          persons:[],
          personID:0

    
        }
      },

     
    
      mounted(){
       
        httpRequests.getperson().then(response=>{
          this.persons=response.data
        })
      
    
        httpRequests.getMyApplications().then(response=>{
 
          this.myApplications=response.data
        })
      },
    
        methods:{

          forwardCorrespondence(chosenCorrespondence){

            if(this.personID>0){

              if(confirm("ნამდვილად გსურთ გადამისამართება?")){

              httpRequests.forwardCorrespondence(chosenCorrespondence,this.personID).then(()=>{
                alert("გადამისამართებულია")
              })


              }

            }

          },


          setStatus(chosenCorrespondence,statusID){

            if(statusID==2){
              if(confirm("ნამდვილად გსურთ დაკმაყოფილება?")){

                httpRequests.setStatusToCorrespondence(chosenCorrespondence,statusID).then(()=>{
                  location.reload()
                })

              }

            }

            if(statusID==3){
              if(confirm("ნამდვილად გსურთ არ დაკმაყოფილება?")){

                httpRequests.setStatusToCorrespondence(chosenCorrespondence,statusID).then(()=>{
                  location.reload()
                })
                

              }

            }

            
          },

          setResolution(chosenCorrespondence){

            if(this.resolution){

              httpRequests.setResolution(chosenCorrespondence,this.resolution).then(()=>{
                alert("რეზოლუცია დადებულია")
              })

            }

          },
       
          showApplication(correspondenceID){
            this.chosenCorrespondence=correspondenceID
            this.moduleName=null
            this.cancelDate=null
            
            this.title=this.myApplications.find(o=>o.correspondence[0].correspondenceID==correspondenceID).correspondence[0].application.applicationName
            this.header=this.myApplications.find(o=>o.correspondence[0].correspondenceID==correspondenceID).correspondence[0].application.header
            this.body=this.myApplications.find(o=>o.correspondence[0].correspondenceID==correspondenceID).correspondence[0].application.body
            this.freeText=this.myApplications.find(o=>o.correspondence[0].correspondenceID==correspondenceID).correspondence[0].freeText
            this.resolution=this.myApplications.find(o=>o.correspondence[0].correspondenceID==correspondenceID).correspondence[0].resolution

            if(this.myApplications.find(o=>o.correspondence[0].correspondenceID==correspondenceID).correspondence[0].application.applicationInputID==1){
               this.moduleName=JSON.parse(this.myApplications.find(o=>o.correspondence[0].correspondenceID==correspondenceID).correspondence[0].applicationInput)[1]
            }


            if(this.myApplications.find(o=>o.correspondence[0].correspondenceID==correspondenceID).correspondence[0].application.applicationInputID==2){
              this.cancelDate=JSON.parse(this.myApplications.find(o=>o.correspondence[0].correspondenceID==correspondenceID).correspondence[0].applicationInput)[2]
            }


          }
          
    
        }
    
    
    
     }
    </script>
    